import PlatformTaxonsList from "./components/PlatformTaxonsList";
import AsidePanel from "./components/AsidePanel";

const PlatformTaxons = () => (
  <div className="main-wrapper">
    <div className="box-300">
      <AsidePanel />
    </div>
    <PlatformTaxonsList />
  </div>
);

export default PlatformTaxons;
